import React from 'react';
import { motion } from 'framer-motion';
import { Building2, GraduationCap, MapPin } from 'lucide-react';

const HostelsPage = () => {
  const hostels = [
    {
      id: 'jodhpur',
      name: 'श्री हिंगुलाज छात्रालय, जोधपुर',
      nameEn: 'Shri Hinglaj Chhatralay, Jodhpur',
      established: '1937',
      buildingYear: '1964',
      address: 'तीसरी रोड़, सरदारपुरा, जोधपुर',
      images: [
        'https://customer-assets.emergentagent.com/job_career-nexus-61/artifacts/m19mulkr_Hostel%20copy.jpg',
        'https://customer-assets.emergentagent.com/job_career-nexus-61/artifacts/iq2qbb6z_Hostel%203%20copy.jpg'
      ],
      content: [
        'भारत की स्वतंत्रता पूर्व ही हमारे समाज में शिक्षा के प्रसार हेतु हमारे तत्कालीन शिक्षा प्रेमियों, समाज सेवियों ने 1937 में जोधपुर में छात्रावास की स्थापना की। उस समय शिक्षा की स्थिति बहुत दयनीय थी। ग्रामीण क्षेत्रों में तो विद्यालयों का भी अभाव था और महाविद्यालय तो कुछ शहरों में ही थे।',
        'ऐसे में हमारे पूर्वजों ने जोधपुर में छात्रावास की स्थापना कर दूरदर्शिता का परिचय दिया। शुरु में तो गांव गांव जाकर समाज के छात्रों को अध्ययन के लिये प्रोत्साहित किया व उन्हें जोधपुर में विद्यालयों व महाविद्यालयों में प्रवेश दिलाया, आवास व सभी आवश्यक व्यवस्थायें कीं।',
        'पहले किराये के मकान में व्यवस्था की व 1964 में छात्रावास भवन की स्थापना हुयी। तीसरी रोड़, सरदारपुरा, जोधपुर स्थित श्री ब्रह्म खत्री भवन ट्रस्ट श्री हिंगुलाज छात्रालय से निकले समाज के विद्यार्थी अनेक उच्च पदों पर पहुंचे। ट्रस्ट द्वारा जरूरतमंदों को पेंशन के रुप में सहायता भी दी जाती रही है।'
      ],
      highlight: 'शिक्षा प्रसार में क्रांतिकारी कदम समय पर उठाने वाले हमारे पूर्वजों को शत शत नमन।'
    },
    {
      id: 'jaipur',
      name: 'श्री ब्रह्मक्षत्रिय (मारवाड़ी) समाज व शिक्षण संस्थान, जयपुर',
      nameEn: 'Shri Brahm Kshatriya (Marwari) Samaj & Shikshan Sansthan, Jaipur',
      established: 'Under Construction',
      buildingYear: 'Final Phase',
      address: 'जयपुर',
      images: [
        'https://customer-assets.emergentagent.com/job_career-nexus-61/artifacts/tqcphfek_Jaipur%20Hostel.jpeg'
      ],
      content: [
        'कोटा के बाद जयपुर अब \'एजूकेशन हब\' के रूप में उभरा है। जयपुर में आधुनिक व्यवस्थाओं के साथ समाज का छात्रावास सहित बहुउद्देशीय भवन का निर्माण अब अंतिम चरण में है।',
        'समयानुकूल व आधुनिक सुविधाओं से युक्त छात्रावास के उपक्रम पर विचार व क्रियान्वयन काफी समय से चल रहा है व अब पूर्णता की ओर है। शीघ्र ही यहां काम शुरु होने की संभावना है।',
        'भवन की भूमी का क्षेत्रफल 645 वर्ग मीटर है व अग्रभाग 120 फिट है। तहखाने में बहुउपयोगी बड़ा हॉल व पुस्तकालय के लिये छोटा हॉल है। भूतल पर मंदिर, कार्यालय व स्वागत कक्ष है। प्रथमतल पर 13 सुसज्जित कमरे समाज की छात्राओं के लिये और द्वितीय तल पर 13 कमरे छात्रों के लिये बनाये गये हैं। तृतीय तल पर डिजीटल क्लास रूम बनाये गये हैं, जिन्हें कोचिंग व ट्यूशन के लिये किराये पर देकर भवन की आय का स्रोत के रूप में रखा गया है।'
      ],
      highlight: 'आधुनिक सुविधाओं से युक्त इस योजना को क्रियान्वित करने वाले समाज बंधुओं का अभिनंदन।'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="gradient-orange py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 text-white/80 text-sm mb-6">
            <a href="/" className="hover:text-white">Home</a>
            <span>›</span>
            <span>Hostels</span>
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              छात्रावास
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Hostels - Educational Facilities for Our Community Students
            </p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Jodhpur Hostel */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
              <Building2 className="w-6 h-6 text-orange-600" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">{hostels[0].name}</h2>
              <p className="text-gray-500">{hostels[0].nameEn}</p>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            <div className="bg-orange-50 rounded-xl p-4 text-center">
              <p className="text-2xl font-bold text-orange-600">{hostels[0].established}</p>
              <p className="text-sm text-gray-600">स्थापना वर्ष</p>
            </div>
            <div className="bg-blue-50 rounded-xl p-4 text-center">
              <p className="text-2xl font-bold text-blue-600">{hostels[0].buildingYear}</p>
              <p className="text-sm text-gray-600">भवन निर्माण</p>
            </div>
            <div className="bg-green-50 rounded-xl p-4 text-center col-span-2">
              <div className="flex items-center justify-center gap-2">
                <MapPin className="w-5 h-5 text-green-600" />
                <p className="text-sm font-medium text-green-700">{hostels[0].address}</p>
              </div>
            </div>
          </div>

          {/* Content and Images - Same layout as Jaipur */}
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            {/* Content - Left */}
            <div className="bg-gray-50 rounded-2xl p-8">
              {hostels[0].content.map((para, index) => (
                <p key={index} className="text-gray-700 text-lg leading-relaxed mb-4 last:mb-0">
                  {para}
                </p>
              ))}
            </div>

            {/* Images - Right */}
            <div className="space-y-4 flex flex-col justify-center">
              {hostels[0].images.map((img, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  className="rounded-xl overflow-hidden shadow-lg"
                >
                  <img
                    src={img}
                    alt={`${hostels[0].name} - ${index + 1}`}
                    className="w-full h-auto"
                  />
                </motion.div>
              ))}
            </div>
          </div>

          {/* Highlight */}
          <div className="mt-6 bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-6 text-white text-center">
            <p className="text-lg font-semibold">{hostels[0].highlight}</p>
          </div>
        </motion.div>

        {/* Divider */}
        <div className="border-t border-gray-200 my-12"></div>

        {/* Jaipur Hostel */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
              <GraduationCap className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">{hostels[1].name}</h2>
              <p className="text-gray-500">{hostels[1].nameEn}</p>
            </div>
          </div>

          {/* Status Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 text-yellow-800 rounded-full mb-6">
            <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></div>
            <span className="font-medium">निर्माण अंतिम चरण में - Under Construction (Final Phase)</span>
          </div>

          {/* Jaipur Hostel Image and Content */}
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            {/* Content */}
            <div className="bg-blue-50 rounded-2xl p-8">
              {hostels[1].content.map((para, index) => (
                <p key={index} className="text-gray-700 text-lg leading-relaxed mb-4 last:mb-0">
                  {para}
                </p>
              ))}
            </div>

            {/* Image - Right aligned, full aspect ratio */}
            {hostels[1].images.length > 0 && (
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                className="rounded-xl overflow-hidden shadow-lg flex items-center"
              >
                <img
                  src={hostels[1].images[0]}
                  alt={hostels[1].name}
                  className="w-full h-auto object-contain"
                />
              </motion.div>
            )}
          </div>

          {/* Highlight */}
          <div className="mt-6 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl p-6 text-white text-center">
            <p className="text-lg font-semibold">{hostels[1].highlight}</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default HostelsPage;
